var _rect, _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIndicator(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 39,
    viewBox: "0 0 30 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.2,
    x: 14,
    y: 19,
    width: 2,
    height: 20,
    fill: "#70C43B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.7321 27C15.9622 28.3333 14.0377 28.3333 13.2679 27L3.74167 10.5C2.97187 9.16666 3.93412 7.5 5.47372 7.5L24.5263 7.5C26.0659 7.5 27.0281 9.16667 26.2583 10.5L16.7321 27Z",
    fill: "#70C43B"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndicator);
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzAiIGhlaWdodD0iMzkiIHZpZXdCb3g9IjAgMCAzMCAzOSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3Qgb3BhY2l0eT0iMC4yIiB4PSIxNCIgeT0iMTkiIHdpZHRoPSIyIiBoZWlnaHQ9IjIwIiBmaWxsPSIjNzBDNDNCIi8+CjxwYXRoIGQ9Ik0xNi43MzIxIDI3QzE1Ljk2MjIgMjguMzMzMyAxNC4wMzc3IDI4LjMzMzMgMTMuMjY3OSAyN0wzLjc0MTY3IDEwLjVDMi45NzE4NyA5LjE2NjY2IDMuOTM0MTIgNy41IDUuNDczNzIgNy41TDI0LjUyNjMgNy41QzI2LjA2NTkgNy41IDI3LjAyODEgOS4xNjY2NyAyNi4yNTgzIDEwLjVMMTYuNzMyMSAyN1oiIGZpbGw9IiM3MEM0M0IiLz4KPC9zdmc+Cg==";
export { ForwardRef as ReactComponent };